import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { deletePartyPayment } from '../../../store/actions/partiesActionCreator';
import * as logger from "../../../logger";

const useStyles = makeStyles((theme) => ({
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    divV1: {
        fontWeight: 300, fontSize: 16
    }
}));

const DeleteTransactionDialog = ({ open, paymentId, onConfirm, onClose, dispatchDeletePartyPayment }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onDelete = () => {

        dispatchDeletePartyPayment(paymentId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Delete Transaction Dialog Dweb", "Delete Transaction Successfull");
                    setDialogOpen(false);
                    onConfirm();
                }
            },
            () => {
                logger.log("Delete Transaction Dialog Dweb", "Delete Transaction Failed");
            }
        )

    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV1}>Do you want to delete the Payment ? </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDelete}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchDeletePartyPayment: (paymentId, onSuccess, onError) => {
        dispatch(deletePartyPayment(paymentId, onSuccess, onError))
    }

})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTransactionDialog)